<template lang="pug">
  .select-technician
    div
      //- BOTON ENTREGAR A RECEPCIÓN
      //- Da salida de bodega a recepción
      button.change-button(
        :disabled="disabled || loading"
        @click="entregarARecepcion()")
        | Entregar a recepción
        b-spinner(v-if="loading" class="ml-2" variant="white" small)
</template>

<script>
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import LoadingButtonMixin from '@/mixins/LoadingButtonMixin'

export default {
  name: 'ActionEntregarRecepcion',
  mixins: [LoadingButtonMixin],
  props: ['ot', 'disabled'],

  data() {
    return {
      state: false,
      usuarios: [],
    }
  },
  methods: {
    ...mapActions('OTStore', ['editOT', 'entregarRecepcion']),
    async entregarARecepcion() {
      try {
        await this.executeWithLoading(async () => {
          const payload = {
            ot: this.ot.ot,
            user: this.user.user.id,
          }
          const resp = await this.entregarRecepcion(payload)
          if (resp.status === 200) {
            await this.editOT({
              ot: this.ot.ot,
              tecnico_asignado: this.ot.tecnico_asignado.id,
              ubicacion: 'Recepción',
            })
            this.$bvToast.toast(
              `OT entregada a recepción a las ${moment(resp.data.fecha_hora).format('DD/MM/YYYY HH:mm')}`,
              {
                variant: 'success',
              }
            )
            this.$emit('changed')
          } else {
            this.$bvToast.toast('Error al entregar a recepción', {
              variant: 'danger',
            })
          }
        })
      } catch (error) {
        console.error('Error al entregar a recepción:', error)
        this.$bvToast.toast('Error al entregar a recepción', {
          variant: 'danger',
        })
      }
    },
  },
  computed: {
    ...mapGetters('AuthenticationStore', ['user']),
  },
}
</script>
